import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { APP_CONFIG } from '@kros-sk/core/app-config';
import { AppInsightsBaseService } from '@kros-sk/core/application-insights';
import { createHttpRetryErrorForLog, httpRetryAndLog, HttpRetryResult } from '@kros-sk/core/http-retry';
import { PermissionFullApiModel, PermissionPostApiModel } from '@kros-sk/models';

import { HandleMethodErrors } from '../../shared/decorators/handle-errors/handle-errors-decorator';
import {
  RequestsWithErrorHandling
} from '../../shared/request-with-error-handling/requests-with-error-handling.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsApiService extends RequestsWithErrorHandling {

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: any,
    private readonly appInsights: AppInsightsBaseService
  ) {
    super(http);
  }

  @HandleMethodErrors({ status: ['401', '402', '504', '500', '502', '503'] })
  loadPermissions(companyId: number, permissions: PermissionPostApiModel[]): Observable<PermissionFullApiModel[]> {
    return this.httpRequest<PermissionFullApiModel[]>(
      'post',
      this.createApiUrl('permissions/filteredByAppType', companyId),
      {
        aggregate: true,
        filter: permissions
      }
    ).pipe(
      httpRetryAndLog({
        retryOnStatus: /^(500|502|503|504)$/,
        retryDelays: [300, 600, 1200],
        loggerFn: this.logHttpRetryException('loadPermissions', 'POST')
      }),
    );
  }

  private createApiUrl(controllerName: string, companyId: number): string {
    return `${this.appConfig.gatewayApiUrl}/companies/${companyId}/${controllerName}`;
  }

  private logHttpRetryException = (apiMethod: string, httpRequestMethod: string) => {
    return (log: HttpRetryResult): void => {
      const handler = 'PermissionsApiService';
      this.appInsights.trackException(createHttpRetryErrorForLog(handler, apiMethod, httpRequestMethod), handler, log);
    };
  };
}
